const state = () => ({
  reauthorizationStarted: false,
  reauthorizationClosed: false,
  dialogTitle: '',
  dialogButtons: [],
  authorizationEmail: false,
  authorizationCode: false,
  daysLeft: null,
  reauthorizationPartner: {},
  partnerBeforeReauthorization: {},
  shouldSeeReauthorization: false,
  dialogLoading: false
});

const getters = {
  reauthorizationClosed(state) {
    return state.reauthorizationClosed;
  },
  dialogTitle(state) {
    return state.dialogTitle;
  },
  dialogButtons(state) {
    return state.dialogButtons;
  },
  authorizationEmail(state) {
    return state.authorizationEmail;
  },
  authorizationCode(state) {
    return state.authorizationCode;
  },
  reauthorizationPartner(state) {
    return state.reauthorizationPartner;
  },
  reauthorizationStarted(state) {
    return state.reauthorizationStarted;
  },
  partnerBeforeReauthorization(state) {
    return state.partnerBeforeReauthorization;
  },
  shouldSeeReauthorization(state) {
    return state.shouldSeeReauthorization;
  },
  dialogLoading(state) {
    return state.dialogLoading;
  }
};

const mutations = {
  setReauthorizationClosed(state, payload) {
    state.reauthorizationClosed = payload;
  },
  setDialogTitle(state, payload) {
    state.dialogTitle = payload;
  },
  setDialogButtons(state, payload) {
    state.dialogButtons = payload;
  },
  setAuthorizationEmail(state, payload) {
    state.authorizationEmail = payload;
  },
  setAuthorizationCode(state, payload) {
    state.authorizationCode = payload;
  },
  setReauthorizationPartner(state, payload) {
    state.reauthorizationPartner = payload;
  },
  setReauthorizationStarted(state, payload) {
    state.reauthorizationStarted = payload;
  },
  setPartnerBeforeReauthorization(state, payload) {
    state.partnerBeforeReauthorization = payload;
  },
  setShouldSeeReauthorization(state, payload) {
    state.shouldSeeReauthorization = payload;
  },
  setDialogLoading(state, payload) {
    state.dialogLoading = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

const actions = {
  setDialogTitle({ commit }, payload) {
    commit('setDialogTitle', payload);
  },
  setDialogButtons({ commit }, payload) {
    commit('setDialogButtons', payload);
  },
  setAuthorizationEmail({ commit }, payload) {
    commit('setAuthorizationEmail', payload);
  },
  setAuthorizationCode({ commit }, payload) {
    commit('setAuthorizationCode', payload);
  },
  setReauthorizationPartner({ commit }, payload) {
    commit('setReauthorizationPartner', payload);
  },
  setReauthorizationStarted({ commit }, payload) {
    commit('setReauthorizationStarted', payload);
  },
  setReauthorizationClosed({ commit }, payload) {
    commit('setReauthorizationClosed', payload);
  },
  setPartnerBeforeReauthorization({ commit }, payload) {
    commit('setPartnerBeforeReauthorization', payload);
  },
  setShouldSeeReauthorization({ commit }, payload) {
    commit('setShouldSeeReauthorization', payload);
  },
  setDialogLoading({ commit }, payload) {
    commit('setDialogLoading', payload);
  }
};

export const reauthorization = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
